import iconTalkSvg from '../assets/print/icon-talk.svg'
import noteSvg from '../assets/print/note.svg'
import { KatexText } from '../components/quiz-types/shared'
import { STEP_CONFIGS, STEP4_LAYOUT } from './constants'

interface Step4SectionProps {
  questions: string[]
  showTitle?: boolean
}

export function Step4Section({ questions, showTitle = true }: Step4SectionProps) {
  const config = STEP_CONFIGS[3]

  return (
    <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
      {/* Title SVG - absolute positioned for manual adjustment */}
      {showTitle && (
        <div style={{ position: 'absolute', left: 72, top: -34, zIndex: 1 }}>
          <img src={config.svg} alt="" width={config.svgWidth} height={config.svgHeight} />
        </div>
      )}

      {/* Pink container with question + note */}
      <div
        style={{
          width: 650,
          background: '#FFE4E4',
          borderRadius: 16,
          padding: '40px 40px 32px',
        }}
      >

        {/* Questions */}
        {questions.map((question, idx) => (
          <div key={idx} style={{ marginBottom: idx < questions.length - 1 ? 32 : 0 }}>
            {/* Question row: icon-talk + text */}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, marginBottom: 24 }}>
              <img src={iconTalkSvg} alt="" width={39} height={24} style={{ flexShrink: 0, marginTop: 4 }} />
              <span style={{ fontSize: 16, fontWeight: 600, lineHeight: 1.875, color: '#131313' }}>
                <KatexText text={question} />
              </span>
            </div>
            {/* Note writing area - full width */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={noteSvg} alt="" width="100%" height={STEP4_LAYOUT.noteHeight} style={{ maxWidth: STEP4_LAYOUT.noteWidth }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
